<template>
  <span class="svg-icon-reward-watch-fitness">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_6262_37994)">
        <circle cx="19.375" cy="19.4639" r="5.625" fill="#9ED9FF"/>
        <path d="M23.75 10.0889H16.25C12.8038 10.0889 10 12.8926 10 16.3389V23.8389C10 27.2851 12.8038 30.0889 16.25 30.0889H23.75C27.1963 30.0889 30 27.2851 30 23.8389V16.3389C30 12.8926 27.1963 10.0889 23.75 10.0889ZM20.7013 24.8151C20.2875 25.1389 19.7125 25.1389 19.2987 24.8151C17.9225 23.7389 15 21.2014 15 19.0389C15 17.5476 16.1188 16.3389 17.5 16.3389C18.8813 16.3389 20 17.3476 20 18.8389C20 17.3476 21.1187 16.3389 22.5 16.3389C23.8813 16.3389 25 17.5476 25 19.0389C25 21.2001 22.0775 23.7389 20.7013 24.8151ZM12.5 8.44512V6.33887C12.5 5.64762 13.0588 5.08887 13.75 5.08887H26.25C26.9412 5.08887 27.5 5.64762 27.5 6.33887V8.44512C26.3612 7.90137 25.0925 7.58887 23.75 7.58887H16.25C14.9075 7.58887 13.6388 7.90262 12.5 8.44512ZM16.25 32.5889H23.75C25.0925 32.5889 26.3612 32.2751 27.5 31.7326V33.8389C27.5 34.5301 26.9412 35.0889 26.25 35.0889H13.75C13.0588 35.0889 12.5 34.5301 12.5 33.8389V31.7326C13.6388 32.2764 14.9075 32.5889 16.25 32.5889Z" fill="#0078FF"/>
      </g>
      <defs>
        <clipPath id="clip0_6262_37994">
          <rect width="30" height="30" fill="white" transform="translate(5 5.08887)"/>
        </clipPath>
      </defs>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
